"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.form.title.edit': 'Edit Profession',
    'profession.form.title.add': 'Add Profession',
    'profession.form.back': 'Back',
    'profession.form.name.label': 'Name',
    'profession.form.name.placeholder': 'Profession name',
    'profession.form.branch.label': 'Branch',
    'profession.form.branch.placeholder': 'Select branch',
    'profession.form.description.label': 'Description',
    'profession.form.description.placeholder': 'Enter profession description',
    'profession.form.image.label': 'Image',
    'profession.form.image.placeholder': 'Upload profession image',
    'profession.form.knowledge.label': 'Knowledge Entries',
    'profession.form.knowledge.placeholder': 'Search knowledge entries...',
    'profession.form.common.label': 'Common Profession',
    'profession.form.active.label': 'Active',
    'profession.form.submit.update': 'Update Profession',
    'profession.form.submit.create': 'Create Profession',
    'profession.form.branches.load.error': 'Failed to load branches',
    'profession.form.steps.load.error': 'Failed to load steps',
    'profession.form.load.error': 'Failed to load profession',
    'profession.form.update.success': 'Profession updated successfully',
    'profession.form.action.success': 'Profession',
    'profession.form.action.error': 'Profession failed to be',
    'profession.form.action.failed': 'Failed to',
    'profession.form.update': 'update',
    'profession.form.create': 'create',
    'profession.form.knowledge.title': 'Knowledge Entries',
    'profession.form.steps.title': 'Steps',
    'profession.form.steps.label': 'Select Steps',
    'profession.form.submit.label': 'Submit',
};
